<template>
  <div id="enterprisedoc" style="height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Enterprisedoc"
};
</script>

<style></style>
